import '../../styles/InteractiveComponents.css';
import '../../styles/FreeText.css';

import {
  FreeTextComponent,
  LessonComponentResponseType
} from '../../../content/models/LessonComponent';
import React, { useEffect, useState } from 'react';
import { isNull, isUndefined } from 'lodash';

import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import { InlineQuillEdit } from '../InlineQuillEdit';
import { LessonComponentContextConsumer } from '../../models/LessonComponentContext';
import componentStyles from  '../../styles/LessonComponents.module.css';
import { useLessonContext } from '../../models/LessonContext';

interface FreeTextProps {
  response: LessonComponentResponseType;
  component: FreeTextComponent;
  onChange: (response: LessonComponentResponseType) => void;
}

export function FreeText(props: FreeTextProps) {
  const { mode, finalized, quizLocked, assessmentSubmitted } =
    useLessonContext();

  const [response, setResponse] = useState<string>(
    (props.response as string) || ''
  );

  useEffect(() => {
    if (!isUndefined(props.response)) {
      setResponse((props.response as string) || '');
    }
  }, [props.response]);

  function handleChange(value: string) {
    if (mode !== 'edit') {
      props.onChange(value);
      setResponse(value);
    }
  }

  return (
    <LessonComponentContextConsumer>
      {({ correct, reattempt }) => (
        <Box className={componentStyles.textOverflow}>
          {/* Set width to work with safari browser */}
          <FormLabel component="legend" style={{ width: '100%' }}>
            <div
              className={mode === 'edit' ? 'disable-textbox' : 'answer-textbox'}
            >
              <InlineQuillEdit
                value={mode !== 'edit' ? response : ''}
                componentKey={props.component.componentkey}
                styleType="noList"
                disable={
                  mode === 'edit' ||
                  mode === 'mark' || //NOT editable for marker
                  (!isNull(correct) && !reattempt) ||
                  quizLocked ||
                  finalized ||
                  assessmentSubmitted
                }
                placeholder={props.component.settings.instructionText}
                onChange={handleChange}
              />
            </div>
          </FormLabel>
        </Box>
      )}
    </LessonComponentContextConsumer>
  );
}
